import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import Env from '../../../env/env';
import {ArtistDocument, getName} from '../../elastic-utils';

@Component({
  selector: 'app-search-artists',
  templateUrl: './search-artists.component.html',
  styleUrls: ['./search-artists.component.css']
})
export class SearchArtistsComponent implements OnInit {
  searchTerm: string;
  private results: ArtistDocument[] = [];
  private getName = getName;

  constructor(private http: HttpClient, private router: Router) {
  }

  ngOnInit() {
  }

  search() {
    if (this.searchTerm) {
      this.http.get<ArtistDocument[]>(Env.apiUrl + '/artists/search?term=' + encodeURIComponent(this.searchTerm)).subscribe((data) => {
        this.results = data;
        console.log(this.results);
      });
    }
  }

  goToArtworkSearch(result: ArtistDocument) {
    this.router.navigate(['search', 'artworks', result._source.id ]);
  }
}
